// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { FetchActionArgs, State } from './types.tsx';
import { fetchData } from './utils.tsx';

export const fetch =
	({ params, header }: FetchActionArgs, forceRefetch = false) =>
	async ({ setState, getState }: StoreActionApi<State>) => {
		const currentState = getState();
		if (!params || currentState.loading || (currentState.data && !forceRefetch)) return;

		setState({
			loading: true,
		});

		try {
			const data = await fetchData({ params, header });
			setState({
				data,
				loading: false,
				error: null,
			});
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (err: any) {
			setState({
				error: err,
				loading: false,
			});
		}
	};
